import React, {FunctionComponent} from 'react'
import {useTranslation} from 'react-i18next'
import { IProps } from './IProps'
import {IResult} from '../../Client/IResult'
import {Currency} from '../../../../App/Components/Format'

const Body: FunctionComponent<IProps> = ({result}) => {
    const {t} = useTranslation()
    const getRow = (dayResult: IResult,  index: number) => {
        const url = `/customers/${dayResult.customerId}`
        return <tr key={`dayResultRow${dayResult.customerId}`}>
            <td key={`firstName${dayResult.customerId}`} ><a href={url}>{dayResult.firstName}</a></td>
            <td key={`lastName${dayResult.customerId}`} >{dayResult.lastName}</td>
            <td key={`totals${dayResult.customerId}`} className={'text-right'}>
                <Currency>{dayResult.total / 100}</Currency>
            </td>
        </tr>
    }

    return <tbody>
        {result.map((dayResult: IResult, index: number) => getRow(dayResult, index))}
    </tbody>
}

export default Body
